import { extensionBlocked } from './antiextension.js';
import { bsha256 } from './sha256.js';

export async function exportCanvasData(canvas) {
    const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
    const offscreenCtx = offscreen.getContext('2d');
    offscreenCtx.drawImage(canvas, 0, 0);
    extensionBlocked.value = true;
    const blob = await offscreen.convertToBlob();
    extensionBlocked.value = false;
    return await bsha256(blob);
}
